import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { AppConstants } from "../../app.constants";
import { Observable, of } from "rxjs";
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ErrorHandlerService } from "src/app/core/services/error-handler.service";


@Injectable({
  providedIn: 'root'
})
export class BusinesscaseStatusDashboardService {

  constructor(private http: HttpClient, private router: Router, private errorHandlerService: ErrorHandlerService) { }

  getBusinessStatus(email): Observable<any> {
    const params = new HttpParams()
      .set('user_email', email.toString());
    return this.http.get(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.BUSINESSCASE.BUSINESS_CASE_STATUS}`, { params }
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  filterBusinessStatus(data): Observable<any> {
    return this.http.post<any[]>(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.BUSINESSCASE.BUSINESS_CASE_STATUS}`,
      data
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }
}
